import {
  Box,
  Button,
  Dialog,
  TextField,
  DialogTitle,
  DialogContent,
  DialogActions,
} from '@mui/material'
import { FC, useState } from 'react'
import { toast } from 'react-toastify'
import { useAppDispatch } from '../../../app/hooks'
import { setAddDeviceCount } from '../ProrithmSlice'
import { addProrithmDevice } from '../../../services/ProrithmServices'
import { constants, messages, ProrithmSocketMessage, regex } from '../Constants'

interface AddDeviceFormProps {
  open: boolean
  setOpen: (open: boolean) => void
  sendMessageOnSocket: (payload: ProrithmSocketMessage) => void
}

const AddDeviceForm: FC<AddDeviceFormProps> = ({
  open,
  setOpen,
  sendMessageOnSocket,
}) => {
  const dispatch = useAppDispatch()
  const [deviceId, setDeviceId] = useState<string>('')
  const [deviceIdErrorText, setDeviceIdErrorText] = useState<string>('')

  const closeAddDeviceDialog = () => {
    setOpen(false)
    setDeviceId('')
    setDeviceIdErrorText('')
  }

  const handleDeviceNameChange = (value: string) => {
    setDeviceId(value)

    if (!regex?.validDevice?.test(value)) {
      setDeviceIdErrorText(constants?.enterValidDeviceId)
    } else {
      setDeviceIdErrorText('')
    }
  }

  const handleAddDevice = async () => {
    setOpen(false)
    const response = await addProrithmDevice(deviceId)
    if (response?.success) {
      toast(messages?.deviceAddedSuccessfully, {
        position: 'bottom-center',
        hideProgressBar: true,
        closeButton: false,
        theme: 'dark',
        autoClose: 4000,
      })
      const addDeviceMessage = {
        messageType: constants?.add,
        messageContent: {
          message: `Device ${response?.data?.deviceId} onboarded successfully.`,
          macId: response?.data?.deviceId ?? '',
          category: constants?.notMapped,
        },
      }
      sendMessageOnSocket(addDeviceMessage)
      dispatch(setAddDeviceCount())
    }
    setDeviceId('')
  }

  return (
    <Dialog id='add-device-dialog' open={open} onClose={closeAddDeviceDialog}>
      <DialogTitle>{constants?.addDevice}</DialogTitle>
      <DialogContent>
        <TextField
          required
          fullWidth
          autoFocus
          type='text'
          margin='dense'
          value={deviceId}
          variant='standard'
          id='new-device-id'
          label='Enter device id'
          helperText={constants?.deviceIdHelperText}
          onChange={(e) => handleDeviceNameChange(e.target.value)}
        />
        {deviceIdErrorText?.length > 0 && (
          <Box color='red'>{deviceIdErrorText}</Box>
        )}
      </DialogContent>
      <DialogActions>
        <Button id='add-device-close-btn' onClick={closeAddDeviceDialog}>
          {constants?.close}
        </Button>
        <Button
          type='submit'
          onClick={handleAddDevice}
          data-testid='add-device-submit-btn'
          disabled={deviceId?.length === 0 || deviceIdErrorText?.length > 0}
        >
          {constants?.submit}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default AddDeviceForm
